import { render, staticRenderFns } from "./LinkPacientePtiVisibleComponente.vue?vue&type=template&id=7c01628a&scoped=true"
import script from "./LinkPacientePtiVisibleComponente.vue?vue&type=script&lang=js"
export * from "./LinkPacientePtiVisibleComponente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c01628a",
  null
  
)

export default component.exports